import { supabase } from '@/integrations/supabase/client';
import type { BrandProfileBranch } from '@/types';

/**
 * Get all brand profile branches for the current user
 */
export async function getBrandProfileBranches(): Promise<BrandProfileBranch[]> {
  const { data, error } = await supabase.functions.invoke('brand-profile-branches', {
    method: 'GET',
  });

  if (error) {
    throw new Error(error.message || 'Failed to fetch brand profile branches');
  }

  return data;
}